module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/carousel_03@2x.56142b8.png";